import { ProcessedMessage } from './useProcessMessage'
import { COMMAND_PREFIX } from '../../pages/Commands'
import { useHistory } from 'react-router-dom'
import { Command, IBackgroundLocationState } from '../../config/appConfig'

/**
 * Messages originating from the Inboxer in order to invoke a EmailFilingSuggestionDialog.
 */
export type EmailFilingSuggestNotification = ProcessedMessage<{
    messageId: string
    userEmail: string
}>

/**
 * Process an e-mail filing suggest event message. This invokes the EmailFilingSuggestionDialog.
 */
export default function useProcessEmailFilingSuggestNotification() {
    const history = useHistory<IBackgroundLocationState>()

    return (message: EmailFilingSuggestNotification) => {
        if (message.data.messageId === undefined) {
            return
        }

        history.push(`${COMMAND_PREFIX}/${Command.EmailFilingSuggest}`, {
            background: history?.location?.state?.background ?? history?.location,
            data: message.data,
        })
    }
}
